import { render, staticRenderFns } from "./SocialFeed.vue?vue&type=template&id=73c2d9e0&scoped=true&"
import script from "./SocialFeed.vue?vue&type=script&lang=js&"
export * from "./SocialFeed.vue?vue&type=script&lang=js&"
import style0 from "./SocialFeed.vue?vue&type=style&index=0&id=73c2d9e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2d9e0",
  null
  
)

export default component.exports